import { isPresent, noop } from "neetocist";
import { Typography } from "neetoui";
import { Link } from "react-router-dom";

import HelpPopover from "components/HelpPopover";

const Card = ({
  title,
  link,
  description,
  Icon,
  onClick = noop,
  helpPopoverProps,
  ...otherProps
}) => {
  const Component = isPresent(link) ? Link : "div";

  return (
    <Component
      {...{ onClick }}
      className="neeto-ui-border-gray-300 neeto-ui-rounded-lg neeto-molecules-share-landing__card flex cursor-pointer flex-col gap-3 border p-3"
      to={link}
      {...otherProps}
    >
      <div className="flex items-center gap-2">
        {Icon && (
          <Icon className="neeto-ui-text-gray-500 flex-shrink-0" size={24} />
        )}
        <Typography
          className="neeto-molecules-share-landing__card-title min-w-0 flex-grow break-words"
          data-testid="share-card-title"
          style="h4"
        >
          {title}
          {helpPopoverProps && (
            <>
              {" "}
              <HelpPopover {...helpPopoverProps} />
            </>
          )}
        </Typography>
      </div>
      {description && (
        <Typography
          className="neeto-molecules-share-landing__card-desc break-words"
          data-testid="share-card-description"
          lineHeight="normal"
          style="body2"
        >
          {description}
        </Typography>
      )}
    </Component>
  );
};

export default Card;
